export default function useSuperAdmin() {
  const mail = localStorage.getItem("mail");
  return mail && (mail === "flo@gamelight.io" || mail === "gunay@gamelight.io");
}
